import React, { useState } from 'react';
import { FaClock, FaArrowRight } from 'react-icons/fa';
import TimeTableModal from './TimeTableModal';
import ContactModal from './ContactModal';


export default function TimeTableSection() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedClass, setSelectedClass] = useState(null);
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    const classData = [
        {
            id: 1,
            title: "Sipsara",
            subTitle: "Gampaha",
            logo: "/hero/classlogo/sipsara.jpg",
            schedules: [
                { day: 'Friday ', time: '05:00 PM - 06:30 PM', class: 'Grade 6 Theory' },
                { day: 'Tuesday ', time: '05:00 PM - 07:00 PM', class: 'Grade 7 Theory' },
                { day: 'Tuesday ', time: '03:00 PM - 05:00 PM', class: 'Grade 8 Theory' },
                { day: 'Thursday ', time: '05:30 PM - 07:30 PM', class: 'Grade 9 Theory' },
                { day: 'Sunday  ', time: '03:30 PM - 05:30 PM', class: 'Grade 10 Theory' },
                { day: 'Monday ', time: '03:00 PM - 05:00 PM', class: 'Grade 11 Theory' },
                { day: 'Monday ', time: '05:00 PM - 07:00 PM', class: 'Grade 11 Paper' },
                { day: 'Thursday ', time: '01:00 PM - 05:00 PM', class: 'Grade 11 Paper' },
            ]
        },
        {
            id: 2,
            title: "Golden Gate",
            subTitle: "Kiribathgoda",
            logo: "/hero/classlogo/goldengate.jpg",
            schedules: [
                { day: 'Friday', time: '03:00 PM - 05:00 PM', class: 'Grade 10 Theory' },
                { day: 'Friday', time: '05:00 PM - 07:00 PM', class: 'Grade 11 Theory' },
            ]
        },
        {
            id: 3,
            title: "Vishwa",
            subTitle: "Nittabuwa",
            logo: "/hero/classlogo/vishwa.jpg",
            schedules: [
                { day: 'Saturday ', time: '05:00 PM - 06:30 PM', class: 'Grade 6 Theory' },
                { day: 'Saturday ', time: '03:00 PM - 05:00 PM', class: 'Grade 7 Theory' },
                { day: 'Saturday ', time: '11:00 AM - 01:00 PM', class: 'Grade 8 Theory' },
                { day: 'Saturday ', time: '01:00 PM - 03:00 PM', class: 'Grade 9 Theory' },
                { day: 'Wednesday ', time: '03:00 PM - 05:00 PM', class: 'Grade 10 Theory' },
                { day: 'Thursday ', time: '03:00 PM - 05:00 PM', class: 'Grade 10 Paper' },
                { day: 'Saturday ', time: '07:30 AM - 10:00 AM', class: 'Grade 11 Theory' },
                { day: 'Wednesday ', time: '05:00 PM - 07:00 PM', class: 'Grade 11 Paper' },
            ]
        },
        {
            id: 4,
            title: "Online",
            subTitle: "ලංකාවටම",
            logo: "/hero/classlogo/online.jpg",
            schedules: [
                { day: 'Tuesday', time: '08:00 PM - 10:00 PM', class: 'Grade 10 Theory' },
                { day: 'Monday', time: '08:00 PM - 10:00 PM', class: 'Grade 11 Theory' },
            ]
        }
    ];

    const handleViewSchedule = (cls) => {
        setSelectedClass(cls);
        setIsModalOpen(true);
    };

    return (
        <section id="timetable" className="py-20 bg-white">
            <div className="max-w-6xl mx-auto px-6">
                {/* Modern Header */}
                <div className="text-center mb-16">
                    <div className="inline-block mb-6">
                        <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-2xl px-6 py-3 shadow-sm">
                            <FaClock className="text-blue-600 text-lg" />
                            <span className="text-blue-700 font-semibold text-sm lemon-milk">CLASS SCHEDULES</span>
                        </div>
                    </div>

                    <h2 className="text-4xl font-black text-gray-900 mb-4 lemon-milk">
                        Time <span className="text-blue-600">Tables</span>
                    </h2>

                    <p className="text-lg text-gray-600 max-w-2xl mx-auto poppins">
                        Choose your academic year and access detailed class schedules designed for your success.
                    </p>
                </div>

                {/* Modern Time Table Cards */}
                <div className="grid md:grid-cols-4 gap-6">
                    {classData.map((cls) => (
                        <div key={cls.id} className="group relative">
                            <div className={`absolute inset-0 ${cls.id % 2 === 0 ? 'bg-gray-500' : 'bg-blue-500'} rounded-2xl transform ${cls.id % 2 === 0 ? '-rotate-1' : 'rotate-1'} group-hover:rotate-0 transition-transform duration-300 opacity-10`}></div>
                            <div className="relative bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center">
                                <div className="w-24 h-24 bg-white overflow-hidden rounded-2xl mx-auto mb-6 flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                                    <img src={cls.logo} alt={`${cls.title} Logo`} className="w-full h-full object-contain" />
                                </div>
                                <h1 className="text-2xl font-bold text-gray-900 mb-3 lemon-milk">{cls.title}</h1>
                                <h3 className="text-xl font-bold text-gray-900 mb-3 lemon-milk">{cls.subTitle}</h3>
                                <p className="text-gray-600 text-sm mb-4 poppins">Academic year schedules and timetables</p>
                                <button
                                    onClick={() => handleViewSchedule(cls)}
                                    className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-100 transition-colors cursor-pointer"
                                >
                                    <span>View Schedule</span>
                                    <FaArrowRight className="text-xs" />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Additional Info Section */}
                <div className="mt-12 bg-gray-50 rounded-2xl p-8 text-center">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 lemon-milk">Need Help with Scheduling?</h3>
                    <p className="text-gray-600 mb-6 poppins">Future academic year planning and schedules</p>
                    <button
                        onClick={() => setIsContactModalOpen(true)}
                        className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors lemon-milk"
                    >
                        Contact Academic Support
                    </button>
                </div>
            </div>

            {/* TimeTable Modal */}
            <TimeTableModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                classInfo={selectedClass}
            />
            {/* Contact Modal */}
            <ContactModal
                isOpen={isContactModalOpen}
                onClose={() => setIsContactModalOpen(false)}
            />
        </section>
    );
}
